// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-shared-input',
//   imports: [],
//   templateUrl: './shared-input.component.html',
//   styleUrl: './shared-input.component.scss'
// })
// export class SharedInputComponent {
import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  FormControl,
  Validator,
  Validators,
  FormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-shared-input',
  imports: [CommonModule, FormsModule],
  templateUrl: './shared-input.component.html',
  styleUrls: ['./shared-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SharedInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SharedInputComponent),
      multi: true,
    },
  ],
})
export class SharedInputComponent
  implements ControlValueAccessor, Validator, OnInit
{
  @Input() type: string = 'text';
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() minlength: number | null = null;
  @Input() maxlength: number | null = null;
  @Input() pattern: string | null = null;
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() step: number | null = null;
  @Input() autocomplete: string = 'off';
  @Input() label: string = '';
  @Input() errorMessages: { [key: string]: string } = {};

  value: any = '';
  onChange: any = () => {};
  onTouched: any = () => {};
  control: FormControl = new FormControl();

  ngOnInit() {
    this.control = new FormControl(
      { value: this.value, disabled: this.disabled },
      this.getValidators()
    );
  }

  writeValue(value: any): void {
    this.value = value;
    this.control.setValue(value);
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  validate(control: FormControl) {
    if (!this.control.validator) {
      return null;
    }
    return this.control.validator(this.control);
  }

  private getValidators() {
    const validators = [];

    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.minlength) {
      validators.push(Validators.minLength(this.minlength));
    }
    if (this.maxlength) {
      validators.push(Validators.maxLength(this.maxlength));
    }
    if (this.pattern) {
      validators.push(Validators.pattern(this.pattern));
    }
    if (this.min) {
      validators.push(Validators.min(this.min));
    }
    if (this.max) {
      validators.push(Validators.max(this.max));
    }

    return validators;
  }

  getErrorMessage(): string {
    if (this.control.errors) {
      const firstError = Object.keys(this.control.errors)[0];

      if (this.errorMessages && this.errorMessages[firstError]) {
        return this.errorMessages[firstError];
      }

      switch (firstError) {
        case 'required':
          return 'This field is required';
        case 'minlength':
          return `Minimum length is ${this.minlength}`;
        case 'maxlength':
          return `Maximum length is ${this.maxlength}`;
        case 'pattern':
          return 'Invalid format';
        case 'min':
          return `Minimum value is ${this.min}`;
        case 'max':
          return `Maximum value is ${this.max}`;
        default:
          return 'Invalid value';
      }
    }
    return '';
  }
}
